/**
 * Bild-Ausrichtung einer Karte (`imageOrientation` aus jedem Umschlag mit `imageUrl`; Spec
 * docs/superpowers/specs/2026-10-31-querformat-karten-drehen-design.md §4/§5). Scryfall
 * speichert jedes Bild hochkant, gedreht wird in der Oberfläche:
 *
 *   'landscape'        Split-Karten, Räume, Planes — jede Seite quer
 *   'landscape_front'  Battles — Vorderseite quer, Rückseite hochkant
 *   'aftermath'        hochkant, Knopf „Drehen" dreht 90° gegen den Uhrzeigersinn
 *   'flip'             hochkant, Knopf „Drehen" dreht 180°
 *   'portrait'         alles andere
 *
 * Fehlt der Wert (optimistisch angelegte Deck-Einträge, laufende Playtest-Sessions,
 * maskierte Karten), gilt hochkant.
 */

/** Liegt die genannte Seite (`'front'` | `'back'`) quer? */
export function isLandscape(orientation, face = 'front') {
  if (orientation === 'landscape') return true;
  if (orientation === 'landscape_front') return face === 'front';
  return false;
}

/** Hat die Karte eine Querdarstellung, für die das Modal seine Bildspalte von Anfang an breit macht? */
export function hasLandscapeView(orientation) {
  return orientation === 'landscape' || orientation === 'landscape_front' || orientation === 'aftermath';
}

/** Ausrichtungen mit Knopf „Drehen". */
export const ROTATABLE = new Set(['aftermath', 'flip']);
